import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../globalInspector/axiosInstance";
import { env } from "../../../../env";
import CommonToast from "../../../../components/_utils/CommonToast";
import ICONS from "../../../../assets/Icons";

const baseUrl = env.REACT_APP_BASE_URL;

export const fetchTdsTransactionDetails = createAsyncThunk(
  "tdsTransactionDetails/fetch",
  async (txn_id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `${baseUrl}/transactions/tds/${txn_id}`,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
          params: {
            txn_id,
          },
        },
      );

      return response.data;
    } catch (error) {
      const message =
        error?.response?.data?.errors?.base?.[0] ||
        error?.response?.data?.error;

      CommonToast({
        text: message,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });

      return rejectWithValue(message);
    }
  },
);

const tdsTransactionDetailsSlice = createSlice({
  name: "tdsTransactionDetails",

  initialState: {
    tdsTransactionDetailsData: null,
    tdsTransactionDetailsLoading: null,
    tdsTransactionDetailsError: null,
  },

  reducers: {
    resetTdsTransactionDetails(state) {
      state.tdsTransactionDetailsData = null;
      state.tdsTransactionDetailsLoading = null;
      state.tdsTransactionDetailsError = null;
    },
  },

  extraReducers: (builder) => {
    builder

      .addCase(fetchTdsTransactionDetails.pending, (state) => {
        state.tdsTransactionDetailsLoading = true;
        state.tdsTransactionDetailsError = null;
        state.tdsTransactionDetailsData = null;
      })

      .addCase(fetchTdsTransactionDetails.fulfilled, (state, action) => {
        state.tdsTransactionDetailsLoading = false;
        state.tdsTransactionDetailsError = null;
        state.tdsTransactionDetailsData = action.payload;
      })

      .addCase(fetchTdsTransactionDetails.rejected, (state, action) => {
        state.tdsTransactionDetailsLoading = false;
        state.tdsTransactionDetailsError = action.payload;
        state.tdsTransactionDetailsData = null;
      });
  },
});

export const { resetTdsTransactionDetails } =
  tdsTransactionDetailsSlice.actions;

export default tdsTransactionDetailsSlice.reducer;
